export const API_ROUTE_ORGANIZATION_MEMBER_GLOBAL =
  '/organizations/:organizationId/global-members';
